import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import GetInTouchFooter from "./GetInTouchFooter";
import { CiCircleChevDown, CiCircleChevUp } from "react-icons/ci";
import TeachingMethodImg from "../assets/TeachingMethodology.svg";
import GirlImg from "../assets/girlHead.svg";
import { useParams, useSearchParams } from "react-router-dom";
import learingImg from "../assets/learning.jpg";
import freedomImg from "../assets/freedom.jpg";
import playImg from "../assets/play.jpg";
import environmentImg from "../assets/environment.jpg";
import { Helmet } from "react-helmet";

const TeachingMethod = () => {
  const [activeIndex, setActiveIndex] = useState(1);
  const [backgroundColor, setBackground] = useState("#FACADD");
  const [searchParams, setSearchParams] = useSearchParams();
  const [image, setImage] = useState(environmentImg);

  useEffect(() => {
    setActiveIndex(searchParams.get("id"));
  }, [searchParams]);

  useEffect(() => {
    window.scrollTo(0, 20);
  }, []);

  useEffect(() => {
    switch (+activeIndex) {
      case 1:
        setBackground("#FACADD");
        setImage(environmentImg);
        break;
      case 2:
        setBackground("#FEE2FF");
        setImage(freedomImg);
        break;
      case 3:
        setBackground("#E7DCFF");
        setImage(playImg);
        break;
      case 4:
        setBackground("#DFECFF");
        setImage(learingImg);
        break;

      default:
        setBackground("#FACADD");
    }
  }, [activeIndex]);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const dropdownArr = [
    {
      id: 1,
      title: "REGGIO EMILIA",
      description: (
        <p className="text-[20px] leading-7 font-normal">
          <>
            Sometimes the greatest teacher is the{" "}
            <span className="text-white inline text-2xl font-bold">
              ENVIRONMENT.
            </span>
          </>
        </p>
      ),

      content: (
        <div className="flex flex-col gap-4 font-normal text-[16px] leading-[26px] text-[#1A1A1A] mb-4">
          <p>
            AS LORIS MALAGUZZI SAID, THE EDUCATOR FROM THE CITY OF REGIO EMILIA,
          </p>
          <p>
            "The child is made of one hundred. The child has a hundred
            languages, a hundred hands, a hundred thoughts, a hundred ways of
            thinking, of playing, of speaking. A hundred always a hundred ways
            of listening, of marveling, of loving; a hundred joys for singing
            and understanding. A hundred worlds to discover; a hundred worlds to
            invent; a hundred worlds to dream."
          </p>
          <p>
            All these hundreds often come from the environment, when you not
            only teach them but also expose them to naturally available
            materials for learning.
          </p>
        </div>
      ),
    },
    {
      id: 2,
      title: "MONTESSORI",
      description: (
        <p className="text-[20px] leading-7 font-normal">
          <>
            Give children{" "}
            <span className="text-white inline text-2xl font-bold">
              {`FREEDOM, `}
            </span>
             to explore. Learning will happen by the way
          </>
        </p>
      ),

      content: (
        <div className="flex flex-col gap-4 font-normal text-[16px] leading-[26px] text-[#1A1A1A] mb-4">
          <p>
          THE THREE-TIME NOBEL PEACE PRIZE NOMINEE WAS THE BRAIN BEHIND MONTESSORI EDUCATION PHILOSOPHY.
          </p>
          <p>
          The three-time Nobel Peace Prize nominee, Maria Montessori, developed the widely practiced Montessori Education policy
          </p>
          <p>
            She once said, 'The hand is the instrument of intelligence, and the
            greatest gift we can give our children are the roots of
            responsibility and the wings of independence.'
          </p>
          <p>
            Hence we believe in freedom, the freedom to help children learn by
            themselves while we are there to support learning, through various
            Montessori teaching aids and equipment.
          </p>
        </div>
      ),
    },
    {
      id: 3,
      title: "PLAY-BASED LEARNING",
      description: (
        <p className="text-[20px] leading-7 font-normal">
          <>
            Because when children
            <span className="text-white inline text-2xl font-bold"> PLAY, </span>
            they learn too.
          </>
        </p>
      ),

      content: (
        <div className="flex flex-col gap-4 font-normal text-[16px] leading-[26px] text-[#1A1A1A] mb-4">
          <p>
            Every child is born curious and it's our responsibility to nurture
            that curiosity. Through daily interactions and play, they explore
            the world, which leads to social, physical, emotional, and cognitive
            growth.
          </p>
          <p>
            Play serves as the ultimate teacher, so we ensure every child has
            ample opportunities to play indoors, outdoors, or at parks.
          </p>
          <p>
            By observing their interests, we ignite their imagination and
            creativity. Whether it's dressing up, building blocks, singing,
            story telling, or outdoor adventures, we seamlessly integrate play
            into everyday activities, inspire them to learn and explore joyfully
          </p>
        </div>
      ),
    },
    {
      id: 4,
      title: "EXPERIENTIAL LEARNING",
      description: (
        <p className="text-[20px] leading-7 font-normal">
          <>
            Learning by doing is
            <span className="text-white inline text-2xl font-bold">
            {` LEARNING `}
            </span>
            for life
          </>
        </p>
      ),

      content: (
        <div className="flex flex-col gap-4 font-normal text-[16px] leading-[26px] text-[#1A1A1A] mb-4">
          <p>
            Experiential learning means doing, thinking, and reflecting. It's
            all about learning by doing. Children start learning when they use
            their senses and reflect on what they've done. Then, they think,
            make meaning, and test their ideas. They learn from feedback and
            move on to the next experience.
          </p>
        </div>
      ),
    },
  ];

  return (
    <div>
      <Helmet>
        <title>Teaching Method at Mother's Pride - Innovative Preschool Learning</title>
        <meta name="description" content="Learn about the innovative teaching methods at Mother's Pride Preschool, combining Montessori, Reggio Emilia, and experiential learning to nurture young minds." />
        <meta name="keywords" content="Mother's Pride dignitaries, education leaders, preschool visitors,influential educators,guest visits" />
        <link rel="canonical" href="https://www.motherspridepreschool.com/teachingMethod" />
      </Helmet>
    <div
      style={{
        lineHeight: "1.6",
      }}
      className="font-Lato text-center"
    >
      {/* Header Section */}
      <div
        style={{ backgroundColor: backgroundColor, padding: "20px 0" }}
        className="flex flex-col items-center px-[6%] font-Lato"
      >
        <div className="flex gap-[1rem] mt-[1rem]">
          <img
            src={GirlImg}
            alt="girl img"
            className="self-end sm:block hidden sm:mr-5 sm:mb-10"
          />
          <div className="sm:w-[60%] text-[1.9rem] sm:text-[4rem] flex flex-col gap-3 items-center">
            <h1 className="font-Wonderbar leading-[1.5rem] sm:leading-[72px] text-white">
              TEACHING
            </h1>
            <h1 className="font-Wonderbar sm:mt-0 mt-1  leading-[1.5rem] sm:leading-[72px] text-black">
              METHODOLOGY
            </h1>
            <p className="text-xl w-[90%] mt-1 sm:mt-4 text-center leading-6 text-[20px]">
              Why should the Teaching methodology be just one and not many
            </p>
          </div>
        </div>
        {/* <p>
          A Culmination of all the best teaching methods in the <br /> world
        </p> */}
      </div>

      {/* Accordion Section */}
      <div
        className="px-[6%] relative py-3 sm:pb-0 pb-10 sm:py-[50px] flex lg:flex-row flex-col gap-[2rem] md:py-[70px] lg:py-[50px] lg:items-center justify-between"
        style={{ background: backgroundColor }}
      >
        <div className="lg:w-[60%]" style={{ background: backgroundColor }}>
          {" "}
          {dropdownArr.map((item, index) => (
            <div
              key={item?.id}
              style={{
                marginBottom: "10px",
                textAlign: "left",
                borderBottom: "1px solid #000000",
                background: backgroundColor,
              }}
            >
              <div>
                <div
                  onClick={() => toggleAccordion(item?.id)}
                  style={{
                    cursor: "pointer",
                    padding: "10px 0px",
                    borderRadius: "5px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className="flex gap-[10px]">
                    <span
                      className="border border-black bg-[#FFFFFF33] rounded-full w-[30px] h-[30px]  flex
                justify-center font-semibold"
                    >
                      {item?.id}
                    </span>
                    <span
                      className="border font-Lato sm:my-0 my-auto lg:text-2xl border-black leading-6 rounded-full px-[20px] flex
                justify-center font-normal bg-[#FFFFFF33]"
                    >
                      {item.title}
                    </span>
                  </div>

                  <span
                    className="text-3xl font-semibold
"
                  >
                    {+activeIndex === item?.id ? (
                      <CiCircleChevUp />
                    ) : (
                      <CiCircleChevDown />
                    )}
                  </span>
                </div>
                <div
                  style={{
                    padding: "10px 0px 10px 0",
                    borderRadius: "5px",
                    marginTop: "5px",
                  }}
                  className="font-Lato"
                >
                  {item.description}
                </div>
              </div>

              {+activeIndex === item?.id && (
                <div
                  style={{
                    borderRadius: "5px",
                    marginTop: "5px",
                  }}
                  className="font-Lato"
                >
                  {item.content}
                </div>
              )}
            </div>
          ))}
        </div>

        <img
          style={{
            borderRadius: "24px",
          }}
          className="lg:absolute object-fit rounded-xl lg:top-[9%] lg:right-[8%] h-[450px] mx-auto w-[340px]"
          src={image}
          alt=""
        />
      </div>

      {/* Contact Section */}
      <GetInTouchFooter marginX={"6%"} />
      <Footer marginX={"6%"} />
    </div>
    </div>
  );
};

export default TeachingMethod;
